














import { Vue, Component, Model } from "vue-property-decorator";
import Size from "@/models/size";
import SizesAPI from "@/services/sizes";

@Component
export default class SizesSelector extends Vue {
  @Model("change") value?: string[];

  sizes: Size[] = [];
  loading = true;

  created(): void {
    this.getSizes();
  }

  get getValue(): string {
    return this.value ? this.value[0] : "";
  }

  async getSizes(): Promise<void> {
    this.loading = true;
    try {
      const r = await SizesAPI.getSizes(1, 100);
      this.sizes = r.data;
    } catch (error) {
      console.log(error);
    } finally {
      this.loading = false;
    }
  }

  emitValue(size: string): void {
    this.$emit("change", [size]);
  }
}
